import { Component, OnInit, ElementRef, Renderer2, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http } from "@angular/http";
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { FormService } from "../Services/form.service";
import { SearchService } from '../Services/search-condition.service';
import { ScService } from '../search-data/sc.service';
import * as constant from '../constant';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-search-condition',
  templateUrl: './search-condition.component.html',
  styleUrls: ['./search-condition.component.css']
})
export class SearchConditionComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  sc = this.scService.sc;
  years: string[];
  months: string[];
  days: string[];
  divisions: string[];
  users: any;
  sales_users: any;
  construction_users: any;
  a1: string[];
  a2: string[];
  a3: string[];
  a8: string[];
  Prefectures: string[];
  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;

  address: any;

  constructor(
    private formService: FormService,
    private _el: ElementRef,
    private renderer: Renderer2,
    private searchService: SearchService,
    private router: Router,
    private scService: ScService,
    public customerInputService: CustomerInputService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.sc = this.scService.sc;
    this.a1 = this.formService.a1;
    this.a2 = this.formService.a2;
    this.a3 = this.formService.a3;
    this.a8 = this.formService.a8;
    this.Prefectures = this.formService.getPrefectures();
    this.years = this.formService.formSetYear(1900);
    this.months = this.formService.formSetMonth();
    this.setDay();

    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['user'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
  }


  //顧客検索
  customerSerch() {
    this.a1.forEach((val, i) => {
      if (this.sc.a1[i]) {
        this.sc.a1[i] = val;
      }
    });
    this.a3.forEach((val, i) => {
      if (this.sc.a3[i]) {
        this.sc.a3[i] = val;
      }
    });
    this.a8.forEach((val, i) => {
      if (this.sc.a8[i]) {
        this.sc.a8[i] = val;
      }
    });
    this.status.forEach((val, i) => {
      if (this.sc.status[i]) {
        this.sc.status[i] = val;
      }
    });
    this.ranks.forEach((val, i) => {
      if (this.sc.rank[i]) {
        this.sc.rank[i] = val;
      }
    });
    this.ranks_ob.forEach((val, i) => {
      if (this.sc.rank_ob[i]) {
        this.sc.rank_ob[i] = val;
      }
    });
    this.scService.sc = this.sc;
    this.router.navigate(['/result/']);
  }

  //リセット
  serchReset() {
    this.sc = Object.assign({}, this.scService.init_sc);
    this.sc.conditions = 'and';
    this.sc.sales_contact_code = '';
    this.sc.division_code = '';
    this.sc.status = {};
    this.sc.rank = {};
    this.sc.rank_ob = {};
    this.a1 = this.formService.a1;
    this.a2 = this.formService.a2;
    this.a3 = this.formService.a3;
    this.a8 = this.formService.a8;
    this.scService.sc = this.sc;
  }

  //担当者絞込用
  userList(division_code) {
    /*
    let list = this.customerInputService.customerBase(division_code);
    list.subscribe(list => {
      this.users = list['user'];
    });
    */
  }

  /**
   * その年と月の日数を取得してくる
   */
  setDay() {
    this.days = this.formService.formSetDay(this.sc.sel_year, this.sc.sel_month)
  }

  /**
   * 郵便番号から住所を取得
   * @param zip 
   */
  searchZip(zip: string) {
    if (zip.length == 7) {
      this.formService.searchZip(zip).then(addr => {
        this.setZip(addr);
      });
    }
  }

  /**
   * 取得した住所をフォームにセット
   * @param addr 
   */
  setZip(addr) {
    if (addr !== undefined) {
      this.sc.pref = addr['0'];
      this.sc.city = addr['1'];
      this.sc.address = addr['2'];
    }
  }

  dp_flg;
  openDp(datePicker) {
    if (this.dp_flg) {
      if (this.dp_flg.isOpen()) {
        if (datePicker == this.dp_flg) {
          this.dp_flg = datePicker;
        } else {
          this.dp_flg.close();
          this.dp_flg = datePicker;
        }
      } else if (datePicker == this.dp_flg) {
        this.dp_flg.close();
        this.dp_flg = "";
      }
    } else {
      this.dp_flg = datePicker;
    }
  }
  closeDp(event) {
    if (this.dp_flg && (event.target.offsetParent == null || event.target.offsetParent.nodeName != "NGB-DATEPICKER")) {
      this.dp_flg.close();
      this.dp_flg = "";
    }
  }

}
